/** Segment track event for rate-selection exposure (no _allocated/_exposed merge in SegmentManager). */
export const segmentTrackEventExperimentExposed = 'Experiment Exposed' as const;
